import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DashboardCard } from '@monorepo/nova-ui';

export const StyledActivityLogCard = styled(DashboardCard)(() => ({
  padding: 'unset',
  width: '100%',
  maxHeight: '700px',

  // Child element styling
  '& > *:not(.MuiDivider-root)': {
    flex: { xs: '1', lg: '1' },
    width: { xs: '100%', lg: '0' },
    minWidth: 0,
    flexBasis: { xs: 'auto', lg: '0' },
    minHeight: { xs: 'auto', lg: 'auto' },
  },

  // First child ordering
  '& > *:first-of-type:not(.MuiDivider-root)': {
    order: { xs: 2, lg: 0 },
  },

  // Last child ordering
  '& > *:last-of-type:not(.MuiDivider-root)': {
    order: { xs: 1, lg: 0 },
  },
}));

export const StyledVerticalDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.text.fifth,
  borderWidth: '1px',
}));

export const StyledHorizontalDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.text.fifth,
  borderWidth: '1px',
  margin: '20px 0',
}));
